<template>
  <toggle-box class="setting" ref="setting">
    <template v-slot:control>
      <div class="button" @click="show">
        <font-awesome-icon :icon="faEllipsisV" />
      </div>
    </template>
    <template v-slot:content>
      <ul>
        <div>
          <li v-for="(select, index) in selects" :key="index" @click="() => toggleOffBtn(select)">
            {{ $t(select) }}
          </li>
        </div>
      </ul>
    </template>
  </toggle-box>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import ToggleBox from '@/components/ToggleBox';
import { ref } from '@vue/composition-api';

const { useActions } = createNamespacedHelpers('paymentReminder');
const { useActions: useModalActions } = createNamespacedHelpers('modal');

const DETAIL = 'DETAIL';

const selects = [
  DETAIL,
];

export default {
  name: 'Setting',
  components: {
    ToggleBox,
    FontAwesomeIcon,
  },
  props: {
    client: Object,
  },
  setup(props) {
    const { targetClient } = useActions(['targetClient']);
    const { togglePaymentReminderClientDetailsModal: toggleDetails } = useModalActions(['togglePaymentReminderClientDetailsModal']);

    const setting = ref(null);

    const show = () => { setting.value.toggle(); };

    const toggleOffBtn = (value) => {
      switch (value) {
        case DETAIL:
          targetClient(props.client);
          toggleDetails();
          break;
        default:
          targetClient(props.client);
          toggleDetails();
      }
      setting.value.toggle();
    };

    return {
      selects,
      setting,
      show,
      toggleOffBtn,
      faEllipsisV,
    };
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/colors";

.setting {
  .button {
    cursor: pointer;
    height: 24px;
    width: 24px;

    &:hover {
      transition: all 0.4s ease-in-out;
      color: $paradisePink;
    }
  }

  /deep/ .toggle-box-wrapper {
    right: -33px;
    padding: 0px;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    width: 100px;

    li {
      background-color: $babyPowder;
      cursor: pointer;
      transition: all .2s ease-in-out;
      text-align: center;
      &:hover {
        background-color: $ghostWhite;
      }
    }
  }
}
</style>
